import React, { createContext, useContext, useMemo } from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const { isLoaded, isSignedIn, user } = useUser();
  const { signOut, getToken } = useClerk();

  const auth = useMemo(
    () => ({
      currentUser: {
        getIdToken: async () => {
          const token = await getToken({ template: 'standard' });
          return token || '';
        },
      },
    }),
    [getToken],
  );

  const normalizedUser = useMemo(() => {
    if (!isSignedIn || !user) return null;

    const role = (user.publicMetadata?.role || 'member').toString();
    const normalizedRole = role === 'super_admin' ? 'superadmin' : role;

    return {
      uid: user.id,
      id: user.id,
      email: user.primaryEmailAddress?.emailAddress || user.emailAddresses?.[0]?.emailAddress || null,
      firstName: user.firstName || null,
      lastName: user.lastName || null,
      profileImageUrl: user.profileImageUrl || null,
      role: normalizedRole,
    };
  }, [isSignedIn, user]);

  return (
    <AuthContext.Provider
      value={{
        user: normalizedUser,
        loading: !isLoaded,
        logout: signOut,
        auth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
